export const STATUS = {
    BUENO: 1,
    REGULAR: 2,
    ALERTA: 3,
    PRE_EMERGENCIA: 4,
    EMERGENCIA: 5,
    NO_DISPONIBLE: 6,
};

export const STATUS_LABEL = {
    [STATUS.BUENO]: 'Bueno',
    [STATUS.REGULAR]: 'Regular',
    [STATUS.ALERTA]: 'Alerta',
    [STATUS.PRE_EMERGENCIA]: 'Pre emergencia',
    [STATUS.EMERGENCIA]: 'Emergencia',
    [STATUS.NO_DISPONIBLE]: 'No disponible',
};

export const STATUS_BG_COLOR = {
    [STATUS.BUENO]: 'green.500',
    [STATUS.REGULAR]: 'yellow.400',
    [STATUS.ALERTA]: 'red.400',
    [STATUS.PRE_EMERGENCIA]: 'purple.300',
    [STATUS.EMERGENCIA]: 'purple.600',
    [STATUS.NO_DISPONIBLE]: 'gray.400',
};

export const STATUS_COLOR_SCHEME = {
    [STATUS.BUENO]: 'green',
    [STATUS.REGULAR]: 'yellow',
    [STATUS.ALERTA]: 'red',
    [STATUS.PRE_EMERGENCIA]: 'purple',
    [STATUS.EMERGENCIA]: 'purple',
    [STATUS.NO_DISPONIBLE]: 'gray',
};
